import PaymentMethod from '../enums/PaymentMethod';
import PurchaseScreenType from '../enums/PurchaseScreenType';
import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';
import UpsellTrigger from '../enums/UpsellTrigger';
import WebProPurchaseLocation from '../enums/WebProPurchaseLocation';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logPurchaseSuccessParams = {
  campaign_id: string;
  payment_method?: PaymentMethod;
  pro_landing_page_experiment_variant_name?: string;
  pro_upsell_experiment_variant_name?: string;
  product_id: string;
  purchase_screen_type?: PurchaseScreenType;
  purchase_screen_type_plan?: PurchaseScreenTypePlan;
  transaction_date: string;
  transaction_id: string;
  upsell_trigger?: UpsellTrigger;
  web_purchase_location?: WebProPurchaseLocation;
};

/**
 * A user successfully completed a purchase OR started a free trial. Note: this is a tad deceptive and a solution is being researched.
 * @param params - Attributes to log with the amplitude event
 * @param params.campaign_id - Campaign associated with the purchase.
 * @param params.payment_method - The method of payment used for the purchase.
 * @param params.pro_landing_page_experiment_variant_name - The name of the variant that is being shown to the user - specific for Optimizely experiment ID: 21475990068.
 * @param params.pro_upsell_experiment_variant_name - The name of the variant that is being shown to the user - specific for an Optimizely experiment.
 * @param params.product_id - Product id of the purchased subscription or trial. This will be different by platform and is a very raw value, e.x. alltrails_pro_threeyear_59_99_int. Note that this can be used to distinguish free trials from other conversions.
 * @param params.purchase_screen_type - The type of screen the pro purchasing event occurs on (e.g. pro carousel, upsell drawer, etc.)
 * @param params.purchase_screen_type_plan - The plan shown on the pro purchasing event occurs on (e.g. trial, non-trial, promo, etc.)
 * @param params.transaction_date - Date of the transaction.
 * @param params.transaction_id - Id of the transaction
 * @param params.upsell_trigger - Action that triggered the upsell to display
 * @param params.user_id - [Deprecated] Legacy user_id field for firebase.
 * @param params.web_purchase_location - The location where the purchase was performed
 */
const logPurchaseSuccess = (
  {
    campaign_id,
    payment_method,
    pro_landing_page_experiment_variant_name,
    pro_upsell_experiment_variant_name,
    product_id,
    purchase_screen_type,
    purchase_screen_type_plan,
    transaction_date,
    transaction_id,
    upsell_trigger,
    web_purchase_location
  }: logPurchaseSuccessParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'purchase success',
    {
      'campaign id': campaign_id,
      'payment method': payment_method,
      'pro landing page experiment variant name': pro_landing_page_experiment_variant_name,
      'variant name': pro_upsell_experiment_variant_name,
      'product id': product_id,
      'purchase screen type': purchase_screen_type,
      'purchase screen type plan': purchase_screen_type_plan,
      'transaction date': transaction_date,
      'transaction id': transaction_id,
      'upsell trigger': upsell_trigger,
      'web purchase location': web_purchase_location
    },
    callback
  );
};

export default logPurchaseSuccess;
